module.exports = __webpack_public_path__ + "static/media/db_icon.abfc998d.svg";